import i18n from '@/libs/i18n'

export default [
  // *===============================================---*
  // *--------- MOM EXPERIENCE ---- ---------------------------------------*
  // *===============================================---*
  {
    path: '/momExperiences/list',
    name: 'pages-momExperiences-list',
    component: () => import('@/views/pages/momExperience/MomExperiencesList.vue'),
    meta: {
      resource: 'momExperience',
      action: 'read',
      breadcrumb: [
        {
          text: i18n.t('general.list'),
          active: false,
        },
      ],
      pageTitle: i18n.t('momExperiences.mainVerticalMenu.momExperiences'),
    },
  },
  {
    path: '/momExperiences/add',
    name: 'pages-momExperiences-add',
    component: () => import('@/views/pages/momExperience/MomExperienceAdd.vue'),
    meta: {
      resource: 'momExperience',
      action: 'create',
      breadcrumb: [
        {
          text: i18n.t('general.add'),
          active: false,
        },
      ],
      pageTitle: i18n.t('momExperiences.mainVerticalMenu.momExperiences'),
    },
  },
  {
    path: '/momExperiences/edit/:id',
    name: 'pages-momExperiences-edit',
    component: () => import('@/views/pages/momExperience/MomExperienceEdit.vue'),
    meta: {
      resource: 'momExperience',
      action: 'update',
      breadcrumb: [
        {
          text: i18n.t('general.edit'),
          active: false,
        },
      ],
      pageTitle: i18n.t('momExperiences.mainVerticalMenu.momExperiences'),
    },
  },
]
